export const categories = [
  {
    id: 'zone1',
    slug: 'yiqu',
    name: '一区精品推荐',
    description: '精选一区优质内容资源，涵盖热门推荐、编辑精选、深度好文等精品内容，为您呈现最具价值的一区内容聚合。',
    icon: 'ri-star-line',
    articleCount: 128,
    subcategories: [
      { slug: 'yiqu-tuijian', name: '热门推荐', count: 42 },
      { slug: 'yiqu-jingxuan', name: '编辑精选', count: 35 },
      { slug: 'yiqu-shendu', name: '深度好文', count: 28 },
      { slug: 'yiqu-zhuanti', name: '专题策划', count: 23 },
    ],
  },
  {
    id: 'zone2',
    slug: 'erqu',
    name: '二区优质资源',
    description: '汇聚二区优质资源内容，包括资源聚合、精品合集、热门资源、特色专栏等多元内容，全方位满足您的二区内容需求。',
    icon: 'ri-sparkling-line',
    articleCount: 156,
    subcategories: [
      { slug: 'erqu-juhe', name: '资源聚合', count: 48 },
      { slug: 'erqu-heji', name: '精品合集', count: 39 },
      { slug: 'erqu-remen', name: '热门资源', count: 36 },
      { slug: 'erqu-zhuanlan', name: '特色专栏', count: 33 },
    ],
  },
  {
    id: 'comprehensive',
    slug: 'zonghe',
    name: '综合分类导览',
    description: '跨区域综合内容导览，打破分区界限，以主题和兴趣为导向，为您提供更全面的内容发现体验。',
    icon: 'ri-compass-3-line',
    articleCount: 89,
    subcategories: [
      { slug: 'zonghe-zhuti', name: '主题聚合', count: 30 },
      { slug: 'zonghe-xinqu', name: '兴趣推荐', count: 28 },
      { slug: 'zonghe-paihang', name: '排行榜单', count: 31 },
    ],
  },
  {
    id: 'latest',
    slug: 'zuixin',
    name: '最新上线',
    description: '实时更新最新上线内容，第一时间获取一区二区新鲜资源，不错过任何精品内容的发布。',
    icon: 'ri-timer-line',
    articleCount: 67,
    subcategories: [
      { slug: 'zuixin-jinri', name: '今日更新', count: 25 },
      { slug: 'zuixin-benzhou', name: '本周上新', count: 42 },
    ],
  },
];

export const allCategorySlugs = categories.flatMap(cat => [
  cat.slug,
  ...cat.subcategories.map(sub => sub.slug),
]);

export function getCategoryBySlug(slug: string) {
  for (const cat of categories) {
    if (cat.slug === slug) return cat;
    for (const sub of cat.subcategories) {
      if (sub.slug === slug) return { ...sub, parentSlug: cat.slug, parentName: cat.name, description: cat.description, icon: cat.icon, isSubcategory: true };
    }
  }
  return null;
}